module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-cleaning-fr-FR@3x-eabccf80e79749cd990c6e8b9fc89111.png";